import { Component, OnDestroy, OnInit } from '@angular/core'
import { UntypedFormControl } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { LanguagesService } from '../../lang/languages.service'
import { getDefaultLanguage, LanguageInfo, LANGUAGES } from '../../lang/languages'

@Component({
  selector: 'app-language-switch',
  templateUrl: './language-switch.component.html',
  styleUrls: ['./language-switch.component.scss']
})
export class LanguageSwitchComponent implements OnInit, OnDestroy {

  languages: LanguageInfo[] = []
  userLanguageCtrl = new UntypedFormControl()

  $destroy = new Subject()

  constructor(private translate: TranslateService, private languagesService: LanguagesService) { }

  ngOnInit(): void {
    this.userLanguageCtrl.valueChanges.pipe(takeUntil(this.$destroy)).subscribe((value: string) => {
      this.translate.use(value)
      this.languagesService.setUserLanguage(value)
      this.refreshLanguageList()
    })

    const userLanguageCode = this.languagesService.getUserLanguage()
    this.userLanguageCtrl.setValue(userLanguageCode || getDefaultLanguage())
  }

  ngOnDestroy(): void {
    this.$destroy.next()
    this.$destroy.complete()
  }

  refreshLanguageList(): void {
    const userLanguageCode = this.languagesService.getUserLanguage()
    this.languages = LANGUAGES.sort((a, b) => {
      const av = a.code === userLanguageCode ? 0 : 1
      const bv = b.code === userLanguageCode ? 0 : 1
      return av - bv
    })
  }

  onChangeLang(code: string): void {
    this.userLanguageCtrl.setValue(code)
  }

}
